import './styles.scss';
import React from 'react';
import DefaultLoader from "../../components/common/DefaultLoader/DefaultLoader";
import {useQuery} from "react-query";
import AlertApi from "../../api/Alert/Alert.api";
import AlertDetails from "../../components/specific/Alerts.details/Alerts.details";
import { RouteComponentProps } from 'react-router-dom';
import moment from "moment";

interface Props extends RouteComponentProps<{alertId:string}>{

}

function AlertContainer({match}: Props) {
    const {isLoading, data} = useQuery([`alert-${match.params.alertId}`, match.params.alertId], AlertApi.getAlertById)

    if (isLoading || !data) {
        return (
            <div className='default-loader-full'>
                <DefaultLoader text='Loading alert...'/>
            </div>
        )
    }

    return (
        <div className='alert-container'>
            <div className='alert-container-header'>
                <div className='title'>
                    Alert for {moment(data.alert.alert_for_date).format("MMM DD, YYYY")}
                </div>
                <div className='subtitle'>
                    {data.alert.user.email}
                </div>
            </div>
            <AlertDetails alertAnalytics={data}/>
        </div>
    )
}

export default AlertContainer;